import React from "react";

const BreadcrumbContext = React.createContext({});

const createBreadCrumbObject = (navigation, component, showBreadcrumb) => {
  const { area, region, coordinator, program, year } = navigation;
  return {
    //adding this property so consumers can respond to wether or not they should
    //render the breadcrumb deeper in.
    navigation: navigation,
    showBreadcrumb: showBreadcrumb,
    onAreaClicked: (clickedArea) => {
      component.navigationLevelClicked(clickedArea);
    },
    onRegionClicked: (clickedRegion) => {
      component.navigationLevelClicked(area, clickedRegion);
    },
    onCoordinatorClicked: (clickedCoordinator) => {
      component.navigationLevelClicked(area, region, clickedCoordinator);
    },
    onProgramClicked: (clickedProgram) => {
      component.navigationLevelClicked(
        area,
        region,
        coordinator,
        clickedProgram
      );
    },
    onYearClicked: (chosenYear) => {
      component.navigationLevelClicked(
        area,
        region,
        coordinator,
        program,
        chosenYear
      );
    },
    onTermClicked: (chosenTerm) => {
      component.navigationLevelClicked(
        area,
        region,
        coordinator,
        program,
        year,
        chosenTerm
      );
    },
  };
};
export { createBreadCrumbObject };
export default BreadcrumbContext;
